export const sampleLaptopDeals = [
  {
    title: 'ASUS VivoBook F510UA',
    link: 'https://www.amazon.com/gp/product/B0762S8PYM/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B0762S8PYM&linkCode=as2&tag=permutize-20&linkId=470e763d20dd1dab1064861923e0a479',
    pictureLink: 'https://images-na.ssl-images-amazon.com/images/I/41ep9XKCNHL._AC_US436_QL65_.jpg',
    manufacturer: 'Asus',
    model: 'F510UA-AH51',
    screen: {
      size: 15.6,
      panelType: 'IPS',
      resolution: {
        width: 1920,
        height: 1080
      },
      touchscreen: false
    },
    weight: 3.7,
    dimensions: {
      length: 14.2,
      width: 9.6,
      height: 0.8
    },
    cpu: {
      title: 'Intel Core i5 8th Gen i5-8250U',
      cores: 4,
      clockSpeed: 1.6,
      manufacturer: 'Intel',
      model: 'Core i5-8250U'
    },
    ram: {
      size: 8,
      manufacturer: '',
      model: '',
      sodimm: 'DDR4'
    },
    hardDisks: [
      {
        type: 'HDD',
        size: 1000,
        manufacturer: '',
        model: '',
        transferSpeed: -1,
        rpm: 5400
      }
    ],
    gpu: {
      type: 'Integrated',
      manufacturer: 'Intel',
      model: 'UHD 620',
      vram: 0
    },
    operatingSystems: [
      {
        type: 'Windows',
        version: 10,
        edition: 'Home'
      }
    ],
    ports: [
      {
        type: 'USB-C',
        version: 'Gen1',
        count: 1
      },
      {
        type: 'USB',
        version: '3.0',
        count: 1
      },
      {
        type: 'USB',
        version: '2.0',
        count: 2
      },
      {
        type: 'HDMI',
        version: '',
        count: 1
      },
      {
        type: 'SD Card Reader',
        version: '',
        count: 1
      },
      {
        type: '3.5mm',
        version: 'microphone in/headphone out',
        count: 1
      },
      {
        type: 'Fingerprint Sensor',
        version: '',
        count: 1
      }
    ],
    opticalDrives: [

    ],
    webcam: true,
    wifi: {
      hasIt: true,
      protocols: [
        'AC'
      ]
    },
    keyboard: {
      backLit: false,
      numericKeypad: false
    },
    bluetooth: {
      hasIt: true,
      version: 0
    },
    // temporary:
    store: 'Amazon',
    storeDisplayName: 'Amazon',
    price: 509.99,
    discount: 0
  },
  {
    title: 'Samsung 11.6" XE501C13-K01US Chromebook',
    link: 'https://www.bestbuy.com/site/samsung-11-6-chromebook-intel-celeron-2gb-memory-16gb-emmc-flash-memory-night-charcoal/6239913.p',
    pictureLink: 'https://pisces.bbystatic.com/image2/BestBuy_US/images/products/6239/6239913_sa.jpg',
    manufacturer: 'Samsung',
    model: 'XE501C13-K01US',
    screen: {
      size: 11.6,
      panelType: '',
      resolution: {
        width: 1366,
        height: 768
      },
      touchscreen: false
    },
    weight: 2.5,
    dimensions: {
      length: 11.4,
      width: 8.1,
      height: 0.7
    },
    cpu: {
      title: 'Intel Celeron N3060',
      cores: 2,
      clockSpeed: 1.6,
      manufacturer: 'Intel',
      model: 'Celeron N3060'
    },
    ram: {
      size: 2,
      manufacturer: '',
      model: '',
      sodimm: 'LPDDR3'
    },
    hardDisks: [
      {
        type: 'SSD',
        size: 16,
        manufacturer: '',
        model: '',
        transferSpeed: -1,
        rpm: 0
      }
    ],
    gpu: {
      type: 'Integrated',
      manufacturer: 'Intel',
      model: 'HD 4000',
      vram: 0
    },
    operatingSystems: [
      {
        type: 'ChromeOS',
        version: 0,
        edition: ''
      }
    ],
    ports: [
      {
        type: 'USB',
        version: '3.0',
        count: 1
      },
      {
        type: 'USB',
        version: '2.0',
        count: 1
      },
      {
        type: 'HDMI',
        version: '',
        count: 1
      },
      {
        type: 'MicroSD Card Reader',
        version: '',
        count: 1
      },
      {
        type: '3.5mm',
        version: 'microphone in/headphone out',
        count: 1
      }
    ],
    opticalDrives: [

    ],
    webcam: true,
    wifi: {
      hasIt: true,
      protocols: [
        'AC'
      ]
    },
    keyboard: {
      backLit: false,
      numericKeypad: false
    },
    bluetooth: {
      hasIt: true,
      version: 0
    },
    // temporary:
    store: 'BestBuy',
    storeDisplayName: 'Best Buy',
    price: 229
  },
  {
    title: 'Samsung 11.6" XE501C13-K02US Chromebook',
    link: 'https://www.bestbuy.com/site/samsung-11-6-chromebook-intel-celeron-4gb-memory-32gb-emmc-flash-memory-night-charcoal/6239912.p',
    pictureLink: 'https://pisces.bbystatic.com/image2/BestBuy_US/images/products/6239/6239913_sa.jpg',
    manufacturer: 'Samsung',
    model: 'XE501C13-K02US',
    screen: {
      size: 11.6,
      panelType: '',
      resolution: {
        width: 1366,
        height: 768
      },
      touchscreen: false
    },
    weight: 2.5,
    dimensions: {
      length: 11.4,
      width: 8.1,
      height: 0.7
    },
    cpu: {
      title: 'Intel Celeron N3060',
      cores: 2,
      clockSpeed: 1.6,
      manufacturer: 'Intel',
      model: 'Celeron N3060'
    },
    ram: {
      size: 4,
      manufacturer: '',
      model: '',
      sodimm: 'LPDDR3'
    },
    hardDisks: [
      {
        type: 'SSD',
        size: 32,
        manufacturer: '',
        model: '',
        transferSpeed: -1,
        rpm: 0
      }
    ],
    gpu: {
      type: 'Integrated',
      manufacturer: 'Intel',
      model: 'HD 4000',
      vram: 0
    },
    operatingSystems: [
      {
        type: 'ChromeOS',
        version: 0,
        edition: ''
      }
    ],
    ports: [
      {
        type: 'USB',
        version: '3.0',
        count: 1
      },
      {
        type: 'USB',
        version: '2.0',
        count: 1
      },
      {
        type: 'HDMI',
        version: '',
        count: 1
      },
      {
        type: 'MicroSD Card Reader',
        version: '',
        count: 1
      },
      {
        type: '3.5mm',
        version: 'microphone in/headphone out',
        count: 1
      }
    ],
    opticalDrives: [

    ],
    webcam: true,
    wifi: {
      hasIt: true,
      protocols: [
        'AC'
      ]
    },
    keyboard: {
      backLit: false,
      numericKeypad: false
    },
    bluetooth: {
      hasIt: true,
      version: 0
    },
    // temporary:
    store: 'BestBuy',
    storeDisplayName: 'Best Buy',
    price: 259,
    discount: 0
  },
  {
    title: 'ASUS VivoBook S410UN-NS74',
    link: 'https://www.amazon.com/gp/product/B07B7VFTN9/ref=as_li_qf_asin_il_tl?ie=UTF8&tag=permutize-20&creative=9325&linkCode=as2&creativeASIN=B07B7VFTN9&linkId=cc8f804bfb34f3232881c73138282722',
    pictureLink: 'https://images-na.ssl-images-amazon.com/images/I/41ARzdDxdFL._AC_US436_QL65_.jpg',
    manufacturer: 'Asus',
    model: 'S410UN-NS74',
    screen: {
      size: 14,
      panelType: '',
      resolution: {
        width: 1920,
        height: 1080
      },
      touchscreen: false
    },
    weight: 3.2,
    dimensions: {
      length: 12.8,
      width: 8.9,
      height: 0.7
    },
    cpu: {
      title: 'Intel Core i7-8550U',
      cores: 4,
      clockSpeed: 1.8,
      manufacturer: 'Intel',
      model: 'Core i7-8550U'
    },
    ram: {
      size: 8,
      manufacturer: '',
      model: '',
      sodimm: 'DDR4'
    },
    hardDisks: [
      {
        type: 'SSD',
        size: 256,
        manufacturer: '',
        model: '',
        transferSpeed: -1,
        rpm: 0
      }
    ],
    gpu: {
      type: 'Discrete',
      manufacturer: 'Nvidia',
      model: 'MX 150',
      vram: 2
    },
    operatingSystems: [
      {
        type: 'Windows',
        version: 10,
        edition: 'Home'
      }
    ],
    ports: [
      {
        type: 'USB-C',
        version: 'Gen1',
        count: 1
      },
      {
        type: 'USB',
        version: '3.0',
        count: 2
      },
      {
        type: 'USB',
        version: '2.0',
        count: 2
      },
      {
        type: 'HDMI',
        version: '',
        count: 1
      },
      {
        type: 'SD Card Reader',
        version: '',
        count: 1
      },
      {
        type: '3.5mm',
        version: 'microphone in/headphone out',
        count: 1
      },
      {
        type: 'Fingerprint Sensor',
        version: '',
        count: 1
      }
    ],
    opticalDrives: [

    ],
    webcam: true,
    wifi: {
      hasIt: true,
      protocols: [
        'AC'
      ]
    },
    keyboard: {
      backLit: true,
      numericKeypad: false
    },
    bluetooth: {
      hasIt: true,
      version: 4.2
    },
    // temporary:
    store: 'Amazon',
    storeDisplayName: 'Amazon',
    price: 799.99,
    discount: 0
  },
  {
    title: 'Acer Spin 3 2-in-1 SP314-51-59NM',
    link: 'https://www.amazon.com/gp/product/B07BMYS47J/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B07BMYS47J&linkCode=as2&tag=permutize-20&linkId=3a09e804e0c929908412186eb3173c58',
    pictureLink: 'https://images-na.ssl-images-amazon.com/images/I/51oBjsy4CuL._AC_US436_QL65_.jpg',
    manufacturer: 'Acer',
    model: 'SP314-51-59NM',
    screen: {
      size: 14,
      panelType: 'IPS',
      resolution: {
        width: 1920,
        height: 1080
      },
      touchscreen: true
    },
    weight: 3.75,
    dimensions: {
      length: 13.2,
      width: 9.,
      height: 0.8
    },
    cpu: {
      title: 'Intel Core i5 8th Gen i5-8250U',
      cores: 4,
      clockSpeed: 1.6,
      manufacturer: 'Intel',
      model: 'Core i5-8250U'
    },
    ram: {
      size: 8,
      manufacturer: '',
      model: '',
      sodimm: 'DDR4'
    },
    hardDisks: [
      {
        type: 'SSD',
        size: 256,
        manufacturer: '',
        model: '',
        transferSpeed: -1,
        rpm: 0
      }
    ],
    gpu: {
      type: 'Integrated',
      manufacturer: 'Intel',
      model: 'UHD 620',
      vram: 0
    },
    operatingSystems: [
      {
        type: 'Windows',
        version: 10,
        edition: 'Home'
      }
    ],
    ports: [
      {
        type: 'USB',
        version: '3.0',
        count: 2
      },
      {
        type: 'USB',
        version: '2.0',
        count: 1
      },
      {
        type: 'HDMI',
        version: '',
        count: 1
      },
      {
        type: 'SD Card Reader',
        version: '',
        count: 1
      },
      {
        type: '3.5mm',
        version: 'microphone in/headphone out',
        count: 1
      }
    ],
    opticalDrives: [

    ],
    webcam: true,
    wifi: {
      hasIt: true,
      protocols: [
        'AC'
      ]
    },
    keyboard: {
      backLit: false,
      numericKeypad: false
    },
    bluetooth: {
      hasIt: true,
      version: 0
    },
    // temporary:
    store: 'Amazon',
    storeDisplayName: 'Amazon',
    price: 599.99,
    discount: 100
  },
  {
    title: 'Apple 13.3" MacBook Pro Mid 2017',
    link: 'https://adorama.evyy.net/c/1288978/51926/1036?u=https%3A%2F%2Fwww.adorama.com%2Facmpxv2lla.html%3Forigterm%3Dmpxv2ll%252fa%26searchredirect%3Dtrue',
    pictureLink: 'https://www.adorama.com/images/Large/acmpxv2lla.jpg',
    manufacturer: 'Apple',
    model: 'MPXV2LL/A',
    screen: {
      size: 13.3,
      panelType: 'IPS',
      resolution: {
        width: 2560,
        height: 1600
      },
      touchscreen: false
    },
    weight: 4,
    dimensions: {
      length: 13.8,
      width: 9.5,
      height: 0.6
    },
    cpu: {
      title: 'Intel Core i5 7th Gen i5-7267U',
      cores: 6,
      clockSpeed: 2.2,
      manufacturer: 'Intel',
      model: 'Core i5-7267U'
    },
    ram: {
      size: 8,
      manufacturer: '',
      model: '',
      sodimm: 'LPDDR3'
    },
    hardDisks: [
      {
        type: 'SSD',
        size: 256,
        manufacturer: '',
        model: '',
        transferSpeed: -1,
        rpm: 0
      }
    ],
    gpu: {
      type: 'Integrated',
      manufacturer: 'Intel',
      model: 'Iris Plus 650',
      vram: 0
    },
    operatingSystems: [
      {
        type: 'MacOS',
        version: 10.13,
        edition: ''
      }
    ],
    ports: [
      {
        type: 'USB-C',
        version: 'Thunderbolt 3',
        count: 4
      },
      {
        type: '3.5mm',
        version: 'microphone in/headphone out',
        count: 1
      },
      {
        type: 'Fingerprint Sensor',
        subtype: 'TouchID',
        version: '',
        count: 1
      }
    ],
    opticalDrives: [
    ],
    webcam: true,
    wifi: {
      hasIt: true,
      protocols: [
        'A',
        'B',
        'G',
        'N',
        'AC'
      ]
    },
    keyboard: {
      backLit: true,
      numericKeypad: false
    },
    bluetooth: {
      hasIt: true,
      version: 4.2
    },
    // temporary:
    store: 'Adorama',
    storeDisplayName: 'Adorama',
    price: 1499,
    discount: 200
  },
  {
    title: 'Apple 13.3" MacBook Air Silver Mid 2017',
    link: 'https://adorama.evyy.net/c/1288978/51926/1036?u=https%3A%2F%2Fwww.adorama.com%2Facmqd42la3.html',
    pictureLink: 'https://www.adorama.com/images/Large/acmqd42la3.jpg',
    manufacturer: 'Apple',
    model: 'Z0UV-MQ423',
    screen: {
      size: 13.3,
      panelType: 'TN',
      resolution: {
        width: 1440,
        height: 900
      },
      touchscreen: false
    },
    weight: 2.96,
    dimensions: {
      length: 12.8,
      width: 8.9,
      height: 0.7
    },
    cpu: {
      title: 'Intel Core i7 5th Gen i7-5650U',
      cores: 2,
      clockSpeed: 2.2,
      manufacturer: 'Intel',
      model: 'Core i7-5650U'
    },
    ram: {
      size: 8,
      manufacturer: '',
      model: '',
      sodimm: 'LPDDR3'
    },
    hardDisks: [
      {
        type: 'SSD',
        size: 512,
        manufacturer: '',
        model: '',
        transferSpeed: -1,
        rpm: 0
      }
    ],
    gpu: {
      type: 'Integrated',
      manufacturer: 'Intel',
      model: 'HD Graphics 6000',
      vram: 0
    },
    operatingSystems: [
      {
        type: 'MacOS',
        version: 10.13,
        edition: ''
      }
    ],
    ports: [
      {
        type: 'USB',
        version: '3.1',
        count: 2
      },
      {
        type: 'MiniDisplayPort',
        version: 'Thunderbolt 2',
        count: 1
      },
      {
        type: '3.5mm',
        version: 'microphone in/headphone out',
        count: 1
      },
      {
        type: 'Fingerprint Sensor',
        subtype: 'TouchID',
        version: '',
        count: 1
      }
    ],
    opticalDrives: [
    ],
    webcam: true,
    wifi: {
      hasIt: true,
      protocols: [
        'A',
        'B',
        'G',
        'N',
        'AC'
      ]
    },
    keyboard: {
      backLit: true,
      numericKeypad: false
    },
    bluetooth: {
      hasIt: true,
      version: 4.0
    },
    // temporary:
    store: 'Adorama',
    storeDisplayName: 'Adorama',
    price: 1499,
    discount: 0
  },
  {
    title: 'ASUS FX503VM-NS52',
    link: 'https://adorama.evyy.net/c/1288978/51926/1036?u=https%3A%2F%2Fwww.adorama.com%2Fasfx503vmn52.html',
    pictureLink: 'https://www.adorama.com/images/Large/asfx503vmn52.jpg',
    manufacturer: 'Asus',
    model: 'FX503VM-NS52',
    screen: {
      size: 15.6,
      panelType: 'IPS',
      resolution: {
        width: 1920,
        height: 1080
      },
      touchscreen: false
    },
    weight: 5.7,
    dimensions: {
      length: 15.1,
      width: 10.3,
      height: 1.0
    },
    cpu: {
      title: 'Intel Core i5 7th Gen i5-7300HQ',
      cores: 4,
      clockSpeed: 2.5,
      manufacturer: 'Intel',
      model: 'Core i5-7300HQ'
    },
    ram: {
      size: 8,
      manufacturer: '',
      model: '',
      sodimm: 'DDR4'
    },
    hardDisks: [
      {
        type: 'SSD',
        size: 128,
        manufacturer: '',
        model: '',
        transferSpeed: -1,
        rpm: 0
      },
      {
        type: 'HDD',
        size: 1000,
        manufacturer: '',
        model: '',
        transferSpeed: -1,
        rpm: 5400
      }
    ],
    gpu: {
      type: 'Discrete',
      manufacturer: 'Nvidia',
      model: 'GeForce GTX 1060',
      vram: 3
    },
    operatingSystems: [
      {
        type: 'Windows',
        version: 10,
        edition: 'Home'
      }
    ],
    ports: [
      {
        type: 'USB',
        version: '3.0',
        count: 3
      },
      {
        type: 'Ethernet',
        version: '100/1000',
        count: 1
      },
      {
        type: 'HDMI',
        version: '2.0',
        count: 1
      },
      {
        type: '3.5mm',
        version: 'microphone in/headphone out',
        count: 1
      }
    ],
    opticalDrives: [
    ],
    webcam: true,
    wifi: {
      hasIt: true,
      protocols: [
        'AC'
      ]
    },
    keyboard: {
      backLit: true,
      numericKeypad: true
    },
    bluetooth: {
      hasIt: true,
      version: 0
    },
    // temporary:
    store: 'Adorama',
    storeDisplayName: 'Adorama',
    price: 849,
    discount: 150
  },
  {
    title: 'ASUSPRO B9440UA-XS74',
    link: 'https://adorama.evyy.net/c/1288978/51926/1036?u=https%3A%2F%2Fwww.adorama.com%2Fasb944uaxs74.html%3Forigterm%3Db9440ua-xs74%26searchredirect%3Dtrue',
    pictureLink: 'https://www.adorama.com/images/300x300/asb944uaxs74.jpg',
    manufacturer: 'Asus',
    model: 'B9440UA-XS74',
    screen: {
      size: 14,
      panelType: '',
      resolution: {
        width: 1920,
        height: 1080
      },
      touchscreen: false
    },
    weight: 2.31,
    dimensions: {
      length: 12.6,
      width: 8.5,
      height: 0.6
    },
    cpu: {
      title: 'Intel Core i7 7th Gen i7-7500U',
      cores: 2,
      clockSpeed: 2.7,
      manufacturer: 'Intel',
      model: 'Core i7-7500U'
    },
    ram: {
      size: 16,
      manufacturer: '',
      model: '',
      sodimm: 'LPDDR3'
    },
    hardDisks: [
      {
        type: 'SSD',
        size: 512,
        manufacturer: '',
        model: '',
        transferSpeed: -1,
        rpm: 0
      }
    ],
    gpu: {
      type: 'Integrated',
      manufacturer: 'Intel',
      model: 'HD 620',
      vram: 0
    },
    operatingSystems: [
      {
        type: 'Windows',
        version: 10,
        edition: 'Pro'
      }
    ],
    ports: [
      {
        type: 'USB-C',
        version: 'Gen 1',
        count: 2
      },
      {
        type: 'HDMI',
        version: '',
        count: 1
      },
      {
        type: 'SD Card Reader',
        version: '',
        count: 1
      },
      {
        type: '3.5mm',
        version: 'microphone in/headphone out',
        count: 1
      },
      {
        type: 'Fingerprint Sensor',
        version: '',
        count: 1
      }
    ],
    opticalDrives: [
    ],
    webcam: true,
    wifi: {
      hasIt: true,
      protocols: [
        'B',
        'G',
        'N',
        'AC'
      ]
    },
    keyboard: {
      backLit: true,
      numericKeypad: false
    },
    bluetooth: {
      hasIt: true,
      version: 4.1
    },
    // temporary:
    store: 'Adorama',
    storeDisplayName: 'Adorama',
    price: 1349,
    discount: 0
  },
  {
    title: 'Apple 15.4" MacBook Pro Mid 2018',
    link: 'https://adorama.evyy.net/c/1288978/51926/1036?u=https%3A%2F%2Fwww.adorama.com%2Facz0v0mr9321.html%3Forigterm%3Dz0v0-mr9321%26searchredirect%3Dtrue',
    pictureLink: 'https://www.adorama.com/images/Large/acz0v0mr9321.jpg',
    manufacturer: 'Apple',
    model: 'Z0V0-MR9321',
    screen: {
      size: 15.4,
      panelType: 'IPS',
      resolution: {
        width: 2880,
        height: 1800
      },
      touchscreen: false
    },
    weight: 4,
    dimensions: {
      length: 13.8,
      width: 9.5,
      height: 0.6
    },
    cpu: {
      title: 'Intel Core i7 8th Gen i7-8750H',
      cores: 6,
      clockSpeed: 2.2,
      manufacturer: 'Intel',
      model: 'Core i7-8750H'
    },
    ram: {
      size: 16,
      manufacturer: '',
      model: '',
      sodimm: 'DDR4'
    },
    hardDisks: [
      {
        type: 'SSD',
        size: 512,
        manufacturer: '',
        model: '',
        transferSpeed: -1,
        rpm: 0
      }
    ],
    gpu: {
      type: 'Discrete',
      manufacturer: 'AMD',
      model: '555X',
      vram: 4
    },
    operatingSystems: [
      {
        type: 'MacOS',
        version: 10.13,
        edition: ''
      }
    ],
    ports: [
      {
        type: 'USB-C',
        version: 'Thunderbolt 3',
        count: 4
      },
      {
        type: '3.5mm',
        version: 'microphone in/headphone out',
        count: 1
      },
      {
        type: 'Fingerprint Sensor',
        subtype: 'TouchID',
        version: '',
        count: 1
      }
    ],
    opticalDrives: [
    ],
    webcam: true,
    wifi: {
      hasIt: true,
      protocols: [
        'A',
        'B',
        'G',
        'N',
        'AC'
      ]
    },
    keyboard: {
      backLit: true,
      numericKeypad: false
    },
    bluetooth: {
      hasIt: true,
      version: 5.0
    },
    // temporary:
    store: 'Adorama',
    storeDisplayName: 'Adorama',
    price: 2499,
    discount: 100
  },
  {
    title: 'Apple 13.3" MacBook Pro Mid 2017',
    link: 'https://adorama.evyy.net/c/1288978/51926/1036?u=https%3A%2F%2Fwww.adorama.com%2Facmpxt2la1.html%3Forigterm%3Dz0uk-mpxt21%26searchredirect%3Dtrue',
    pictureLink: 'https://www.adorama.com/images/Large/acmpxt2la1.jpg',
    manufacturer: 'Apple',
    model: 'Z0UK-MPXT21',
    screen: {
      size: 13.3,
      panelType: 'IPS',
      resolution: {
        width: 2560,
        height: 1600
      },
      touchscreen: false
    },
    weight: 3,
    dimensions: {
      length: 12.0,
      width: 8.4,
      height: 0.6
    },
    cpu: {
      title: 'Intel Core i5 7th Gen i5-7360U',
      cores: 2,
      clockSpeed: 2.3,
      manufacturer: 'Intel',
      model: 'Core i5-7360U'
    },
    ram: {
      size: 16,
      manufacturer: '',
      model: '',
      sodimm: 'LPDDR3'
    },
    hardDisks: [
      {
        type: 'SSD',
        size: 256,
        manufacturer: '',
        model: '',
        transferSpeed: -1,
        rpm: 0
      }
    ],
    gpu: {
      type: 'Integrated',
      manufacturer: 'Intel',
      model: 'Iris Pro 640',
      vram: 0
    },
    operatingSystems: [
      {
        type: 'MacOS',
        version: 10.13,
        edition: ''
      }
    ],
    ports: [
      {
        type: 'USB-C',
        version: 'Thunderbolt 3',
        count: 2
      },
      {
        type: 'DisplayPort',
        version: 'Thunderbolt 3',
        count: 2
      },
      {
        type: '3.5mm',
        version: 'microphone in/headphone out',
        count: 1
      }
    ],
    opticalDrives: [
    ],
    webcam: true,
    wifi: {
      hasIt: true,
      protocols: [
        'A',
        'B',
        'G',
        'N',
        'AC'
      ]
    },
    keyboard: {
      backLit: true,
      numericKeypad: false
    },
    bluetooth: {
      hasIt: true,
      version: 4.2
    },
    // temporary:
    store: 'Adorama',
    storeDisplayName: 'Adorama',
    price: 1649,
    discount: 50
  },
  {
    title: 'Apple 15.4" MacBook Pro Mid 2018',
    link: 'https://adorama.evyy.net/c/1288978/51926/1036?u=https%3A%2F%2Fwww.adorama.com%2Facmr942lla.html%3Forigterm%3Dmr942ll%252fa%26searchredirect%3Dtrue',
    pictureLink: 'https://www.adorama.com/images/Large/acmr942lla.jpg',
    manufacturer: 'Apple',
    model: 'MR942LL/A',
    screen: {
      size: 15.4,
      panelType: 'IPS',
      resolution: {
        width: 2880,
        height: 1800
      },
      touchscreen: false
    },
    weight: 4,
    dimensions: {
      length: 13.8,
      width: 9.5,
      height: 0.6
    },
    cpu: {
      title: 'Intel Core i7 8th Gen i7-8850H',
      cores: 6,
      clockSpeed: 2.6,
      manufacturer: 'Intel',
      model: 'Core i7-8850H'
    },
    ram: {
      size: 16,
      manufacturer: '',
      model: '',
      sodimm: 'DDR4'
    },
    hardDisks: [
      {
        type: 'SSD',
        size: 512,
        manufacturer: '',
        model: '',
        transferSpeed: -1,
        rpm: 0
      }
    ],
    gpu: {
      type: 'Discrete',
      manufacturer: 'AMD',
      model: '560X',
      vram: 4
    },
    operatingSystems: [
      {
        type: 'MacOS',
        version: 10.13,
        edition: ''
      }
    ],
    ports: [
      {
        type: 'USB-C',
        version: 'Thunderbolt 3',
        count: 4
      },
      {
        type: '3.5mm',
        version: 'microphone in/headphone out',
        count: 1
      },
      {
        type: 'Fingerprint Sensor',
        subtype: 'TouchID',
        version: '',
        count: 1
      }
    ],
    opticalDrives: [
    ],
    webcam: true,
    wifi: {
      hasIt: true,
      protocols: [
        'A',
        'B',
        'G',
        'N',
        'AC'
      ]
    },
    keyboard: {
      backLit: true,
      numericKeypad: false
    },
    bluetooth: {
      hasIt: true,
      version: 5.0
    },
    // temporary:
    store: 'Adorama',
    storeDisplayName: 'Adorama',
    price: 2699,
    discount: 100
  },
  {
    title: 'MSI GT63 Titan 4k',
    link: 'https://www.amazon.com/gp/product/B07CDD2259/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B07CDD2259&linkCode=as2&tag=permutize-20&linkId=c5fce8f40a6bafb26be568ea9cbc7a66',
    pictureLink: 'https://images-na.ssl-images-amazon.com/images/I/51LpJOKVWML._AC_US436_QL65_.jpg',
    manufacturer: 'MSI',
    model: 'FX504GE',
    screen: {
      size: 15.6,
      panelType: 'IPS',
      resolution: {
        width: 3840,
        height: 2160
      },
      touchscreen: false
    },
    weight: 4.7,
    dimensions: {
      length: 25.2,
      width: 10.3,
      height: 1.0
    },
    cpu: {
      title: 'Intel Core i7 8th Gen i7-8850H',
      cores: 6,
      clockSpeed: 2.6,
      manufacturer: 'Intel',
      model: 'Core i7-8850H'
    },
    ram: {
      size: 16,
      manufacturer: '',
      model: '',
      sodimm: 'DDR4'
    },
    hardDisks: [
      {
        type: 'SSD',
        size: 256,
        manufacturer: '',
        model: '',
        transferSpeed: -1,
        rpm: 0
      },
      {
        type: 'HDD',
        size: 1000,
        manufacturer: '',
        model: '',
        transferSpeed: -1,
        rpm: 7200
      }
    ],
    gpu: {
      type: 'Discrete',
      manufacturer: 'Nvidia',
      model: 'GeForce GTX 1080',
      vram: 8
    },
    operatingSystems: [
      {
        type: 'Windows',
        version: 10,
        edition: 'Home'
      }
    ],
    ports: [
      {
        type: 'USB-C',
        version: 'Gen2',
        count: 1
      },
      {
        type: 'USB',
        version: '3.1',
        count: 3
      },
      {
        type: 'USB',
        version: '2.0',
        count: 1
      },
      {
        type: 'Ethernet',
        version: '100/1000',
        count: 1
      },
      {
        type: 'DisplayPort',
        version: '1.2',
        count: 1
      },
      {
        type: 'HDMI',
        version: '',
        count: 1
      },
      {
        type: '3.5mm',
        version: 'microphone in/headphone out',
        count: 1
      }
    ],
    opticalDrives: [
    ],
    webcam: true,
    wifi: {
      hasIt: true,
      protocols: [
        'AC'
      ]
    },
    keyboard: {
      backLit: true,
      numericKeypad: true
    },
    bluetooth: {
      hasIt: true,
      version: 5.0
    },
    // temporary:
    store: 'Amazon',
    storeDisplayName: 'Amazon',
    price: 2599,
    discount: 0
  },
  {
    title: 'Apple 15.4" MacBook Pro Mid 2018',
    link: 'https://adorama.evyy.net/c/1288978/51926/1036?u=https%3A%2F%2Fwww.adorama.com%2Facz0v0mr9357.html%3Forigterm%3Dz0v0-mr9357%26searchredirect%3Dtrue',
    pictureLink: 'https://www.adorama.com/images/Large/acz0v0mr9357.jpg',
    manufacturer: 'Apple',
    model: 'Z0V0-MR9357',
    screen: {
      size: 15.4,
      panelType: 'IPS',
      resolution: {
        width: 2880,
        height: 1800
      },
      touchscreen: false
    },
    weight: 4,
    dimensions: {
      length: 13.8,
      width: 9.5,
      height: 0.6
    },
    cpu: {
      title: 'Intel Core i7 8th Gen i9-8950HK',
      cores: 6,
      clockSpeed: 2.6,
      manufacturer: 'Intel',
      model: 'Core i9-8950HK'
    },
    ram: {
      size: 32,
      manufacturer: '',
      model: '',
      sodimm: 'DDR4'
    },
    hardDisks: [
      {
        type: 'SSD',
        size: 1000,
        manufacturer: '',
        model: '',
        transferSpeed: -1,
        rpm: 0
      }
    ],
    gpu: {
      type: 'Discrete',
      manufacturer: 'AMD',
      model: '560X',
      vram: 4
    },
    operatingSystems: [
      {
        type: 'MacOS',
        version: 10.13,
        edition: ''
      }
    ],
    ports: [
      {
        type: 'USB-C',
        version: 'Thunderbolt 3',
        count: 4
      },
      {
        type: '3.5mm',
        version: 'microphone in/headphone out',
        count: 1
      },
      {
        type: 'Fingerprint Sensor',
        subtype: 'TouchID',
        version: '',
        count: 1
      }
    ],
    opticalDrives: [
    ],
    webcam: true,
    wifi: {
      hasIt: true,
      protocols: [
        'A',
        'B',
        'G',
        'N',
        'AC'
      ]
    },
    keyboard: {
      backLit: true,
      numericKeypad: false
    },
    bluetooth: {
      hasIt: true,
      version: 5.0
    },
    // temporary:
    store: 'Adorama',
    storeDisplayName: 'Adorama',
    price: 3899,
    discount: 0
  },
  {
    title: 'Lenovo Ideapad 720S 15"',
    link: 'https://lenovo.7eer.net/c/1288978/218864/3808?u=https%3A%2F%2Fwww.lenovo.com%2Fus%2Fen%2Flaptops%2Fideapad%2Fideapad-700-series%2FIdeapad-720S-15%2Fp%2F81AC0006US',
    pictureLink: 'https://www.lenovo.com/medias/ip-720s-subseries.png?context=bWFzdGVyfHJvb3R8MTM0MTk0fGltYWdlL3BuZ3xoNTYvaGY0Lzk2OTcxODEzNjgzNTAucG5nfDMzNGI5Mzc0YmJjOTA1ODkxNzdiNjgwNTYzNGJkODFkMTUwMzBmMmRiNDIwMzZmZDE1ODg2MWU3YTZkZmM4MGI',
    manufacturer: 'Lenovo',
    model: '81AC0006US',
    screen: {
      size: 15.6,
      panelType: 'IPS',
      resolution: {
        width: 1920,
        height: 1080
      },
      touchscreen: false
    },
    weight: 4.2,
    dimensions: {
      length: 14.1,
      width: 9.6,
      height: 0.7
    },
    cpu: {
      title: 'Intel Core i7 7th Gen i7-7700HQ',
      cores: 4,
      clockSpeed: 2.8,
      manufacturer: 'Intel',
      model: 'Core i7-7700HQ'
    },
    ram: {
      size: 8,
      manufacturer: '',
      model: '',
      sodimm: 'DDR4'
    },
    hardDisks: [
      {
        type: 'SSD',
        size: 512,
        manufacturer: '',
        model: '',
        transferSpeed: -1,
        rpm: 0
      }
    ],
    gpu: {
      type: 'Discrete',
      manufacturer: 'Nvidia',
      model: '1050 Ti',
      vram: 4
    },
    operatingSystems: [
      {
        type: 'Windows',
        version: 10,
        edition: 'Home'
      }
    ],
    ports: [
      {
        type: 'USB-C',
        version: 'Gen1',
        count: 1
      },
      {
        type: 'USB-C',
        version: 'Thunderbolt',
        count: 1
      },
      {
        type: 'USB',
        version: '3.0',
        count: 1
      },
      {
        type: 'SD Card Reader',
        version: '',
        count: 1
      },
      {
        type: '3.5mm',
        version: 'microphone in/headphone out',
        count: 1
      },
      {
        type: 'Fingerprint Sensor',
        version: '',
        count: 1
      }
    ],
    opticalDrives: [

    ],
    webcam: true,
    wifi: {
      hasIt: true,
      protocols: [
        'AC'
      ]
    },
    keyboard: {
      backLit: true,
      numericKeypad: true
    },
    bluetooth: {
      hasIt: true,
      version: 4.1
    },
    // temporary:
    store: 'Lenovo',
    storeDisplayName: 'Lenovo',
    price: 1049.99,
    discount: 450
  },
  {
    title: 'Lenovo Ideapad 330S 14"',
    link: 'https://lenovo.7eer.net/c/1288978/218864/3808?u=https%3A%2F%2Fwww.lenovo.com%2Fus%2Fen%2Flaptops%2Fideapad%2Fideapad-300-series%2FIdeapad-330S-14-Intel%2Fp%2F81F40038US%3FPID%3D1288978',
    pictureLink: 'https://www.lenovo.com/medias/ideapad-330s-14-hero.png?context=bWFzdGVyfHJvb3R8MTcyMDU2fGltYWdlL3BuZ3xoZDAvaDliLzk3MjIxMzA4NTgwMTQucG5nfDhlZTcwMTA1NzBlZTc1OWYwM2YzOTJjMWQwZjIzNTM4ZTMxZGM2YzEwNjBjNDhmODYzZDZkMjYxMmNjMDIyZjI',
    manufacturer: 'Lenovo',
    model: '81F40038US',
    screen: {
      size: 14,
      panelType: 'IPS',
      resolution: {
        width: 1920,
        height: 1080
      },
      touchscreen: false
    },
    weight: 3.5,
    dimensions: {
      length: 12.6,
      width: 8.9,
      height: 0.7
    },
    cpu: {
      title: 'Intel Core i5 8th Gen i5-8250U',
      cores: 4,
      clockSpeed: 2.8,
      manufacturer: 'Intel',
      model: 'Core i5-8250U'
    },
    ram: {
      size: 8,
      manufacturer: '',
      model: '',
      sodimm: 'DDR4'
    },
    hardDisks: [
      {
        type: 'HDD',
        size: 1000,
        manufacturer: '',
        model: '',
        transferSpeed: -1,
        rpm: 5400
      }
    ],
    gpu: {
      type: 'Integrated',
      manufacturer: 'Intel',
      model: 'UHD 620',
      vram: 0
    },
    operatingSystems: [
      {
        type: 'Windows',
        version: 10,
        edition: 'Home'
      }
    ],
    ports: [
      {
        type: 'USB-C',
        version: 'Gen1',
        count: 1
      },
      {
        type: 'USB',
        version: '3.0',
        count: 2
      },
      {
        type: 'HDMI',
        version: '2.0',
        count: 1
      },
      {
        type: 'SD Card Reader',
        version: '',
        count: 1
      },
      {
        type: '3.5mm',
        version: 'microphone in/headphone out',
        count: 1
      }
    ],
    opticalDrives: [

    ],
    webcam: true,
    wifi: {
      hasIt: true,
      protocols: [
        'AC'
      ]
    },
    keyboard: {
      backLit: false,
      numericKeypad: false
    },
    bluetooth: {
      hasIt: true,
      version: 4.1
    },
    // temporary:
    store: 'Lenovo',
    storeDisplayName: 'Lenovo',
    price: 479.99,
    discount: 200
  },
  {
    title: 'Lenovo Ideapad 720S 13"',
    link: 'https://lenovo.7eer.net/c/1288978/218864/3808?u=https%3A%2F%2Fwww.lenovo.com%2Fus%2Fen%2Flaptops%2Fideapad%2Fideapad-700-series%2FIdeapad-720S-13-AMD%2Fp%2F81BR003PUS',
    pictureLink: 'https://www.lenovo.com/medias/lenovo-laptop-ideapad-720s-13-amd-silver-hero.png?context=bWFzdGVyfHJvb3R8NzMxNTR8aW1hZ2UvcG5nfGgwOC9oNjUvOTYyMTQxNjkzNTQ1NC5wbmd8MmNhZWUyZGNhNWRiNWQyNDNkODVlMjFlNDgyOWI3M2E2NzQyNWIxNTMwYzlkNjFhOTcyNGRhMzJkOWU0YTY2ZA',
    manufacturer: 'Lenovo',
    model: '81BR003PUS',
    screen: {
      size: 13,
      panelType: 'IPS',
      resolution: {
        width: 1920,
        height: 1080
      },
      touchscreen: false
    },
    weight: 2.4,
    dimensions: {
      length: 12,
      width: 8.4,
      height: 0.5
    },
    cpu: {
      title: 'AMD Ryzen 5 2500U',
      cores: 4,
      clockSpeed: 2,
      manufacturer: 'AMD',
      model: 'Ryzen 5 2500U'
    },
    ram: {
      size: 8,
      manufacturer: '',
      model: '',
      sodimm: 'DDR4'
    },
    hardDisks: [
      {
        type: 'SSD',
        size: 512,
        manufacturer: '',
        model: '',
        transferSpeed: -1,
        rpm: 0
      }
    ],
    gpu: {
      type: 'Integrated',
      manufacturer: 'AMD',
      model: 'Vega 8',
      vram: 0
    },
    operatingSystems: [
      {
        type: 'Windows',
        version: 10,
        edition: 'Home'
      }
    ],
    ports: [
      {
        type: 'USB-C',
        version: 'Gen1',
        count: 2
      },
      {
        type: 'USB',
        version: '3.0',
        count: 1
      },
      {
        type: '3.5mm',
        version: 'microphone in/headphone out',
        count: 1
      },
      {
        type: 'Fingerprint Sensor',
        version: '',
        count: 1
      }
    ],
    opticalDrives: [

    ],
    webcam: true,
    wifi: {
      hasIt: true,
      protocols: [
        'AC'
      ]
    },
    keyboard: {
      backLit: true,
      numericKeypad: false
    },
    bluetooth: {
      hasIt: true,
      version: 4.1
    },
    // temporary:
    store: 'Lenovo',
    storeDisplayName: 'Lenovo',
    price: 599.99,
    discount: 450
  },
  {
    title: 'Dell Inspiron 5579 2-in-1 15.6"',
    link: 'https://adorama.evyy.net/c/1288978/51926/1036?u=https%3A%2F%2Fwww.adorama.com%2Fdei55797961g.html',
    pictureLink: 'https://www.adorama.com/images/Large/dei55797961g.jpg',
    manufacturer: 'Dell',
    model: 'I5579-7961GRY',
    screen: {
      size: 15.6,
      panelType: 'IPS',
      resolution: {
        width: 1920,
        height: 1080
      },
      touchscreen: true
    },
    weight: 4.6,
    dimensions: {
      length: 15,
      width: 10,
      height: 0.8
    },
    cpu: {
      title: 'Intel Core i7 8th Gen 8550U',
      cores: 4,
      clockSpeed: 1.8,
      manufacturer: 'Intel',
      model: 'Core i7-8550U'
    },
    ram: {
      size: 16,
      manufacturer: '',
      model: '',
      sodimm: 'DDR4'
    },
    hardDisks: [
      {
        type: 'SSD',
        size: 512,
        manufacturer: '',
        model: '',
        transferSpeed: -1,
        rpm: 0
      }
    ],
    gpu: {
      type: 'Integrated',
      manufacturer: 'Intel',
      model: 'UHD 620',
      vram: 0
    },
    operatingSystems: [
      {
        type: 'Windows',
        version: 10,
        edition: 'Home'
      }
    ],
    ports: [
      {
        type: 'USB',
        version: '3.1',
        count: 2
      },
      {
        type: 'USB',
        version: '2.0',
        count: 1
      },
      {
        type: 'HDMI',
        version: '1.4a',
        count: 1
      },
      {
        type: 'SD Card Reader',
        version: '',
        count: 1
      },
      {
        type: '3.5mm',
        version: 'microphone in/headphone out',
        count: 1
      },
      {
        type: 'Fingerprint Sensor',
        version: '',
        count: 1
      }
    ],
    opticalDrives: [

    ],
    webcam: true,
    wifi: {
      hasIt: true,
      protocols: [
        'AC'
      ]
    },
    keyboard: {
      backLit: true,
      numericKeypad: false
    },
    bluetooth: {
      hasIt: true,
      version: 4.1
    },
    // temporary:
    store: 'Adorama',
    storeDisplayName: 'Adorama',
    price: 899.99,
    discount: 200
  },
  {
    title: 'Dell Alienware 17 R5 17.3"',
    link: 'https://adorama.evyy.net/c/1288978/51926/1036?u=https%3A%2F%2Fwww.adorama.com%2Fdeaw17r57108.html',
    pictureLink: 'https://www.adorama.com/images/Large/deaw17r57108.jpg',
    manufacturer: 'Dell',
    model: 'AW17R5-7108SLV',
    screen: {
      size: 17.3,
      panelType: 'IPS',
      resolution: {
        width: 1920,
        height: 1080
      },
      touchscreen: false
    },
    weight: 9.7,
    dimensions: {
      length: 16.7,
      width: 13.1,
      height: 1.2
    },
    cpu: {
      title: 'Intel Core i7 8th Gen 8750U',
      cores: 6,
      clockSpeed: 2.2,
      manufacturer: 'Intel',
      model: 'Core i7-8750H'
    },
    ram: {
      size: 8,
      manufacturer: '',
      model: '',
      sodimm: 'DDR4'
    },
    hardDisks: [
      {
        type: 'SSD',
        size: 256,
        manufacturer: '',
        model: '',
        transferSpeed: -1,
        rpm: 0
      },
      {
        type: 'HDD',
        size: 1000,
        manufacturer: '',
        model: '',
        transferSpeed: -1,
        rpm: 7200
      }
    ],
    gpu: {
      type: 'Discrete',
      manufacturer: 'Nvidia',
      model: '1060 OC',
      vram: 6
    },
    operatingSystems: [
      {
        type: 'Windows',
        version: 10,
        edition: 'Home'
      }
    ],
    ports: [
      {
        type: 'USB-C',
        version: 'Gen2',
        count: 1
      },
      {
        type: 'USB',
        version: '3.1',
        count: 2
      },
      {
        type: 'Ethernet',
        version: '100/1000',
        count: 1
      },
      {
        type: 'MiniDisplayPort',
        version: 'Thunderbolt 3',
        count: 1
      },
      {
        type: 'HDMI',
        version: '2.0',
        count: 1
      },
      {
        type: '3.5mm',
        version: 'microphone in',
        count: 1
      },
      {
        type: '3.5mm',
        version: 'headphone out',
        count: 1
      }
    ],
    opticalDrives: [

    ],
    webcam: true,
    wifi: {
      hasIt: true,
      protocols: [
        'AC'
      ]
    },
    keyboard: {
      backLit: true,
      numericKeypad: true
    },
    bluetooth: {
      hasIt: true,
      version: 5
    },
    // temporary:
    store: 'Adorama',
    storeDisplayName: 'Adorama',
    price: 1569.95,
    discount: 130
  },
  {
    title: 'Dell XPS 9370 13.3"',
    link: 'https://adorama.evyy.net/c/1288978/51926/1036?u=https%3A%2F%2Fwww.adorama.com%2Fdeaw17r57108.html',
    pictureLink: 'https://www.adorama.com/images/Large/dexps9370700.jpg',
    manufacturer: 'Dell',
    model: 'XPS9370-7002SLV',
    screen: {
      size: 13.3,
      panelType: 'IPS',
      resolution: {
        width: 1920,
        height: 1080
      },
      touchscreen: false
    },
    weight: 2.7,
    dimensions: {
      length: 11.9,
      width: 7.8,
      height: 0.5
    },
    cpu: {
      title: 'Intel Core i7 8th Gen 8550U',
      cores: 4,
      clockSpeed: 1.8,
      manufacturer: 'Intel',
      model: 'Core i7-8550U'
    },
    ram: {
      size: 8,
      manufacturer: '',
      model: '',
      sodimm: 'LPDDR3'
    },
    hardDisks: [
      {
        type: 'SSD',
        size: 256,
        manufacturer: '',
        model: '',
        transferSpeed: -1,
        rpm: 0
      }
    ],
    gpu: {
      type: 'Integrated',
      manufacturer: 'Intel',
      model: 'UHD 620',
      vram: 0
    },
    operatingSystems: [
      {
        type: 'Windows',
        version: 10,
        edition: 'Home'
      }
    ],
    ports: [
      {
        type: 'USB-C',
        version: 'Gen2',
        count: 2
      },
      {
        type: 'USB-C',
        version: '3.1',
        count: 1
      },
      {
        type: 'SD Card Reader',
        version: '',
        count: 1
      },
      {
        type: '3.5mm',
        version: 'microphone in/headphone out',
        count: 1
      }
    ],
    opticalDrives: [

    ],
    webcam: true,
    wifi: {
      hasIt: true,
      protocols: [
        'AC'
      ]
    },
    keyboard: {
      backLit: true,
      numericKeypad: true
    },
    bluetooth: {
      hasIt: true,
      version: 0
    },
    // temporary:
    store: 'Adorama',
    storeDisplayName: 'Adorama',
    price: 1299,
    discount: 200.95
  }
];


// WEBPACK FOOTER //
// ./src/lib/laptop.js